import { URL_CHANGE_RESPONSIBLE } from "../../router/Url";



export const ChangeResponsible = async (DATA) => {
  console.log(DATA)

  return new Promise(async (resolve, reject) => {
    let query = await fetch(URL_CHANGE_RESPONSIBLE,{
      method: 'PUT',
      headers: {
        'authorization': "marcuxo",
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(DATA)
    })
    let responsito = await query.json();
    console.log(responsito);
    if(responsito.success){
      alert("La OT fue Reasignada con Exito")
      resolve(responsito.success)
    }else{
      console.log('ERROR REGISTRO');
      if(responsito.message === "500")resolve(alert('Error de servidor, Intentelo mas tarde'))
      if(responsito.message === "404")resolve(alert('Error de servidor, Intentelo mas tarde'))
    }
  })
 
}
